











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class PGRowBooleanValue extends Vue {
  @Prop() private value!: boolean;
  @Prop() private isEditable!: boolean;
  private textValue!: boolean;

  constructor() {
    super();
    this.textValue = this.value;
  }

  saveChange(): void {
    this.$emit('valueChanged', this.textValue);
  }

  @Watch('value')
  refresh() {
    this.textValue = this.value;
  }
}
